import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFoundPage() {
  return (
    <div className="bg-[#11161a] text-white min-h-[70vh] flex items-center justify-center py-20 px-4">
      <Helmet>
        <title>Siden blev ikke fundet (404) - T.H Byg</title>
      </Helmet>

      <div className="max-w-2xl text-center space-y-6">
        <div className="inline-flex h-20 w-20 items-center justify-center rounded-2xl bg-[#d92323] text-white text-3xl font-black shadow-2xl">
          404
        </div>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
          Siden blev desværre ikke fundet
        </h1>

        <p className="text-slate-300 text-base leading-relaxed">
          Vi kunne ikke finde den side, du leder efter. Måske er adressen tastet forkert, eller siden er flyttet.
        </p>

        <div className="pt-4 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="rounded-full bg-[#d92323] px-6 py-3 text-sm font-bold text-white hover:bg-[#b81b1b] transition-all"
          >
            Gå til Forsiden
          </Link>
          <Link
            to="/staaltag"
            className="rounded-full bg-amber-400 text-slate-900 px-6 py-3 text-sm font-black hover:bg-amber-300 transition-all"
          >
            Ståltag
          </Link>
          <Link
            to="/ydelser"
            className="rounded-full bg-slate-800 border border-slate-700 px-6 py-3 text-sm font-bold text-white hover:bg-slate-700 transition-all"
          >
            Ydelser
          </Link>
          <Link
            to="/projekter"
            className="rounded-full bg-slate-800 border border-slate-700 px-6 py-3 text-sm font-bold text-white hover:bg-slate-700 transition-all"
          >
            Projekter
          </Link>
          <Link
            to="/kontakt"
            className="rounded-full bg-slate-800 border border-slate-700 px-6 py-3 text-sm font-bold text-white hover:bg-slate-700 transition-all"
          >
            Kontakt
          </Link>
        </div>
      </div>
    </div>
  );
}
